<vw-toast-popup [isOpen]="isOpen" [title]="'calendar.climate.info.title' | translate" (close)="onClose()">
  <div class="flex flex-col gap-6 px-4 pb-6">
    <div class="flex items-center gap-4">
      <img src="/assets/images/willy/resized/willy_openhands.png" alt="" class="h-20 w-20 shrink-0 object-contain" />
      <p class="text-body text-vw-body">
        {{ 'calendar.climate.info.message' | translate }}
      </p>
    </div>
    <vw-button data-testid="climate-info-ok-btn" look="primary" [label]="'calendar.climate.info.ok'" customClass="w-full"
      (onClick)="onClose()"></vw-button>
  </div>
</vw-toast-popup>
